import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { RegistrationOverview } from "interface/registration";
import { GrideDateFormatter } from "ui/Date";
import { formatAmount } from "utils/formatters"

interface RegistrationOverviewMobileListProps {
	items: RegistrationOverview[];
	loading: boolean;
	onViewLandingNote?: (item: RegistrationOverview) => void;
	onViewSalesNote?: (item: RegistrationOverview) => void;
	onLoadMore: () => void;
}

const RegistrationOverviewMobileList: FC<
	RegistrationOverviewMobileListProps
> = ({ items, loading, onViewLandingNote, onViewSalesNote, onLoadMore }) => {
	const { t } = useTranslation();

	const empty = useMemo(
		() => !loading && items.length === 0,
		[items.length, loading],
	);

	const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
		const target = event.currentTarget;
		const remaining =
			target.scrollHeight - target.scrollTop - target.clientHeight;
		if (remaining < 200) {
			onLoadMore();
		}
	};

	return (
		<div className="landing-note-list-mobile" onScroll={handleScroll}>
			{empty && (
				<div className="landing-note-list-mobile-empty">{t("NoRows")}</div>
			)}

			{items.map((item, itemIndex) => {
				const itemKey = `${item.registrationId}-${itemIndex}`;
				const showLandingButton = (item.numberOfLandingNotes ?? 0) > 0;
				const showSalesButton = (item.numberOfSalesNotes ?? 0) > 0;

				return (
					<div key={itemKey} className="landing-note-list-card">
						{/* <div className="landing-note-list-card-header">
		
							<div className="landing-note-list-card-note">
								{item.registrationId}
							</div>
							<div className="landing-note-list-card-vessel">
								{item.vesselName || "-"}
							</div>
							<div className="landing-note-list-card-date">
								<GrideDateFormatter
									date={item.registrationTime}
									formatType="dd.MM.yyyy"
									noTd={true}
								/>
							</div>
						</div> */}

						<div className="landing-note-list-card-body">
							<div>
								<span>{t("RegistrationIdShort")}</span>

								<strong>{item.registrationId || "-"}</strong>
							</div>
							<div>
								<span>{t("RegistrationTime")}</span>
								<strong>
									<GrideDateFormatter
										date={item.registrationTime}
										formatType="HH:mm"
										noTd={true}
									/>
								</strong>
							</div>
							<div>
								<span>{t("DeliveryDateShort")}</span>
								<strong>
									<GrideDateFormatter
										date={item.landingTime || ""}
										formatType="dd.MM.yyyy"
										noTd={true}
									/>
								</strong>
							</div>
							<div>
								<span>{t("VesselRegistrationNo")}</span>
								<strong>{item.vesselRegistrationId}</strong>
							</div>
							<div>
								<span>{t("VesselName")}</span>
								<strong>{item.vesselName}</strong>
							</div>
							<div>
								<span>{t("Species")}</span>
								<strong>{item.species}</strong>
							</div>
							<div>
								<span>{t("CatchArea")}</span>
								<strong>{item.catchField}</strong>
							</div>
							<div>
								<span>{t("FishingGear")}</span>
								<strong>{item.fishingGear}</strong>
							</div>
							<div>
								<span>{t("Weight")}</span>
								<strong>{formatAmount(item.amount)}</strong>
							</div>
						</div>

						<div className="landing-note-list-card-actions registration-list-card-actions">
							{showLandingButton && (
								<button
									type="button"
									className="landing-note-list-icon-btn"
									onClick={() => onViewLandingNote?.(item)}
									title={`FD ${t("LandingNotes")}`}
								>
									<span style={{ fontWeight: 600 }}>L</span>
								</button>
							)}
							{showSalesButton && (
								<button
									type="button"
									className="landing-note-list-icon-btn"
									onClick={() => onViewSalesNote?.(item)}
									title={`FD ${t("SalesNotes")}`}
								>
									<span style={{ fontWeight: 600 }}>S</span>
								</button>
							)}
						</div>
					</div>
				);
			})}

			{loading && (
				<div className="landing-note-list-mobile-loading">{t("Loading")}</div>
			)}
		</div>
	);
};

export default RegistrationOverviewMobileList;
